export default __webpack_public_path__ + "static/media/cursor-crosshairs.a51a6c54.svg";